export default __webpack_public_path__ + "static/media/infantil.665a0e95.webp";